import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ChevronLeft } from 'lucide-react';
import PublicHeader from '../Layout/PublicHeader';
import AppTopbarBrand from '../Layout/AppTopbarBrand';

/**
 * Hülle der Unterseiten des Profils: Benachrichtigungen, Passwort ändern, Konto löschen
 * (30.10.2026).
 *
 * Vorher hatte jede ihren eigenen Kopf: Benachrichtigungen eine weiße Leiste mit Pfeil und
 * Schaltern in Indigo, Passwort und Konto löschen einen runden Knopf über einer mittig
 * schwebenden Karte. Jetzt derselbe Kopf wie auf den Detailseiten (am Handy `AppTopbarBrand`,
 * am Rechner `PublicHeader` und ein Rückweg über dem Titel), derselbe Titel und dieselben
 * Gruppen wie im Profil (`.pf-gruppe`).
 */
export const ProfilUnterseite: React.FC<{ titel: string; children: React.ReactNode; aktion?: React.ReactNode }> = ({ titel, children, aktion }) => {
  const navigate = useNavigate();
  const zurueck = () => {
    if ((window.history.state?.idx ?? 0) > 0) navigate(-1);
    else navigate('/profile');
  };
  return (
    <div className="has-bottom-nav" style={{ minHeight: '100vh', background: '#F5F3F3', display: 'flex', flexDirection: 'column' }}>
      <div className="hide-mobile"><PublicHeader /></div>
      <div className="app-topbar hide-desktop"><AppTopbarBrand onBack={zurueck} /></div>
      <main className="pf-unterseite">
        <button type="button" className="pf-zurueck hide-mobile" onClick={zurueck}><ChevronLeft size={16} aria-hidden />Profil</button>
        <div className="pf-unterseite-kopf">
          <h1 className="pf-unterseite-titel">{titel}</h1>
          {aktion}
        </div>
        {children}
      </main>
    </div>
  );
};

/** Eine Zeile mit Schalter: Titel, eine Zeile Erklärung, rechts der Schalter in der Markenfarbe. */
export const SchalterZeile: React.FC<{
  titel: string; text?: string; checked: boolean; disabled?: boolean; onChange: () => void;
}> = ({ titel, text, checked, disabled, onChange }) => (
  <label className={`pf-zeile pf-schalterzeile${disabled ? ' pf-zeile--aus' : ''}`}>
    <span className="pf-text">{titel}{text && <span className="pf-zusatz pf-zusatz--umbruch">{text}</span>}</span>
    <input type="checkbox" role="switch" checked={checked} disabled={disabled} onChange={onChange} />
    <span className="pf-schalter" aria-hidden />
  </label>
);
